import type { TRuleWithTheme } from '@ackee/fela';

import { BackgroundMode } from '../../PixelatedBackgroundWrapper/constants';

type Props = { backgroundMode: BackgroundMode };

export const box: TRuleWithTheme<Props> = () => ({
    paddingBottom: '3.5rem',

    tabletLarge: {
        paddingBottom: '5rem',
    },
});

export const extendTitle: TRuleWithTheme<Props> = ({ theme: { colors }, backgroundMode }) => ({
    fontSize: '2rem',
    lineHeight: '1.24',
    color: backgroundMode === BackgroundMode.Dark ? colors.cyan : colors.blue,
    marginTop: 0,
    display: 'inline',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',

    backgroundImage: 'linear-gradient(to right, blue 75%, blue 75%)',
    backgroundPosition: '0px 1.34em',
    backgroundRepeat: 'repeat-x',
    backgroundSize: '8px 2px',

    tablet: {
        fontSize: '2rem',
        lineHeight: 1.3,
    },

    ':hover': {
        color: colors.fuchsia,
    },
});

export const extendText: TRuleWithTheme<Props> = ({ theme: { colors }, backgroundMode }) => ({
    marginTop: '2.3125rem',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: backgroundMode === BackgroundMode.Dark ? colors.white : colors.black,
    width: '100%',
});

export const extendLink: TRuleWithTheme<Props> = () => ({
    textDecoration: 'none',
});
